(function (global, factory) {
    factory(require('jquery'))
}(this, (function ($) { 'use strict';

    global.Header = {
        options: {
            menu: false,
        },
        menu: {
            show: function () {
                window.dispatchEvent(new Event('resize'));
                document.getElementById('login-menu').style.display = 'flex'
                this.options.menu = true
            },
            hide: function (e) {
                if (! e.target.classList.contains('btn-login') && this.options.menu) {
                    document.getElementById('login-menu').style.display = 'none'
                    this.options.menu = false
                }
            },
            place: function () {
                function getOffset() {
                    return document.querySelector('.btn-login').getBoundingClientRect().left - 123
                }
                document.getElementById('login-menu').style.left = getOffset() + 'px'
            }
        },
        events: {
            header: () => {
                const header = document.querySelector('header')
                const offset = document.getElementById('sticky-banner').offsetHeight;
                if (! header.classList.contains('opened')) {
                    const observer = new window.IntersectionObserver(([obj]) => {
                        if (obj.isIntersecting) {
                            header.classList.remove('opened')
                            return
                        }
                        header.classList.add('opened')
                    }, {
                        root: null,
                        rootMargin: '-' + offset + 'px 0px 0px 0px',
                        threshold: 1,
                    })

                    observer.observe(document.querySelector('#search'))
                }
            },
            login: function () {
                const btnLogin = document.querySelector('.btn-login')
                if (btnLogin) btnLogin.addEventListener('click', this.menu.show.bind(this))
                window.addEventListener('resize', this.menu.place)
                document.addEventListener('click', this.menu.hide.bind(this))
            }
        },
        init: function () {
            if (document.querySelector('#search'))
                this.events.header()
            this.events.login.bind(this)()
        }
    };

})));
